export const FETCH_MANAGER_DASHBOARD = "FETCH_MANAGER_DASHBOARD";
export const FETCH_ADMIN_DASHBOARD = "FETCH_ADMIN_DASHBOARD";
export const FETCH_EMPLOYEE_PENDING_REQUESTS =
  "FETCH_EMPLOYEE_PENDING_REQUESTS";
export const FETCH_ESS_REMINDERS = "FETCH_ESS_REMINDERS";
export const FETCH_ATTENDANCE_DASHBOARD = "FETCH_ATTENDANCE_DASHBOARD";
export const FETCH_ATTENDANCE_TIMESHEET = "FETCH_ATTENDANCE_TIMESHEET";
